import * as React from 'react';

type ExerciseRequirements =
  "drillsOneToSix" |
  "drillSeven";

interface FormattedRequirementProps {
  exercise: ExerciseRequirements;
}

const requirements = {
  drillsOneToSix: {
    equipmentRequired: 'TRS; a suitably sized catching ball.',
    participantNumber: 'Two. For a variation, in Drills 1 to 6, an additional participant may be added to each side to play as a team against the other pair.',
    suitability: 'ALL standards.',
    areaRequired: 'Three metres wide to allow for the screen and five metres either side of the screen.',
    focus: 'To progress through simple catching and retrieving functions in preparation for more complex drills.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching, stopping the ball.',
    setUp: 'Children stand facing each other either side of the TRS. Each player stands approximately four metres from the TRS.'
  },
  drillSeven: {
    equipmentRequired: 'TRS; a suitably sized catching ball, two stumps, cones or targets for the progression.',
    participantNumber: 'One to throw the ball and a rotating line of up to 6 players.',
    suitability: 'May not be suitable for beginners or younger participants, but suitable for all other standards.',
    areaRequired: 'Eight metres wide to allow for the screen and targets and ten metres either side of the screen.',
    focus: 'To progress catching and retrieving functions under distraction and to enhance throwing and accuracy skills.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching, stopping and throwing the ball.',
    setUp: 'The ball thrower stands one side of the screen with targets (stumps, cones) positioned four metres to either side. The participants form a line behind each other on the opposite side of the screen.'
  }
};

const FormattedRequirement = ({ exercise }: FormattedRequirementProps) => {
  let req = requirements[exercise];

  return (
    <p>
      <strong>Equipment required:</strong> {req.equipmentRequired}<br />
      <strong>Number of Participants:</strong> {req.participantNumber}<br />
      <strong>Standard suitability:</strong> {req.suitability}<br />
      <strong>Area Required:</strong> {req.areaRequired}<br />
      <strong>Focus:</strong> {req.focus}<br />
      <strong>Skills Involved:</strong> {req.skillsInvolved}<br />
      <strong>Set Up:</strong> {req.setUp}
    </p>
  )
};

export {
  FormattedRequirement,
};
